import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=c0fc8fb4"
import script from "./TransactionsList.vue?vue&type=script&lang=ts"
export * from "./TransactionsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports